interface RenderCapacitySnapshot {
  memoryFreeBytes: number | null;
  diskFreeBytes: number | null;
  loadAverage: number | null;
  memoryReserveBytes?: number | null;
  memoryPerRenderBytes?: number | null;
  shortMemoryPerRenderBytes?: number | null;
  minFreeDiskBytes?: number | null;
}

const MB = 1_000_000;
const DEFAULT_RESERVE = 1_750 * MB;
const DEFAULT_SHORT_BUDGET = 1_000 * MB;
const DEFAULT_STANDARD_BUDGET = 1_500 * MB;
const formatMB = (bytes: number) => `${Math.ceil(bytes / MB)} MB`;

export function renderFarmWaitHint(node: RenderCapacitySnapshot): string {
  const reasons: string[] = [];
  const memory = node.memoryFreeBytes;
  const reserve = node.memoryReserveBytes ?? DEFAULT_RESERVE;
  const shortThreshold = reserve + (node.shortMemoryPerRenderBytes ?? DEFAULT_SHORT_BUDGET);
  const standardThreshold = reserve + (node.memoryPerRenderBytes ?? DEFAULT_STANDARD_BUDGET);
  if (memory != null && memory < standardThreshold) {
    if (memory >= shortThreshold) {
      reasons.push(`RAM: Short może się zmieścić (próg ${formatMB(shortThreshold)}), standardowy render potrzebuje jeszcze ${formatMB(standardThreshold - memory)}.`);
    } else {
      reasons.push(`RAM: do progu Short (${formatMB(shortThreshold)}) brakuje ${formatMB(shortThreshold - memory)}, a do standardowego renderu (${formatMB(standardThreshold)}) ${formatMB(standardThreshold - memory)}.`);
    }
  }

  const disk = node.diskFreeBytes;
  const minDisk = node.minFreeDiskBytes ?? 1024 ** 3;
  if (disk != null && disk < minDisk) {
    reasons.push(`Dysk: brakuje ${formatMB(minDisk - disk)} do minimalnego zapasu.`);
  }

  if (reasons.length) return reasons.join(' ');
  const load = node.loadAverage == null ? '' : ` Load (1 min): ${node.loadAverage.toFixed(2)}.`;
  return `RAM i dysk są powyżej minimum; slot blokuje bieżący limit CPU lub współbieżności. Renderer sprawdzi ponownie automatycznie.${load}`;
}
